// extracted by css-extract-rspack-plugin
export default {"icon":"icon-CAasBA","label":"label-sKus5w","holdIcon":"holdIcon-uEFLHL","holdValue":"holdValue-SgYX0s"};